import ApiCollection              from '@widesk-core/models/ApiCollection';
import CodeModel                  from './services/code/CodeModel';
import CodeTypePropertyValueModel from './services/code/CodeTypePropertyValueModel';

/**
 * Liste, en une seule requête, les valeurs de la propriété de type de code `visual_url`
 * des codes donnés : visuel du produit Shop pour les tickets Shop, visuel du produit
 * Gespass pour les codes Gespass.
 */
export const listVisualUrls = async (
	codes: CodeModel[],
	collection: ApiCollection<CodeTypePropertyValueModel>,
) => {
	const codeTypeIds = [...new Set(codes.map(code => code.getId('codeType')))].filter(Boolean);

	await collection
		.setFilter('codeTypeProperty.reference', ['visual_url'])
		.listBy(codeTypeIds, 'codeType', { params: { itemsPerPage: codeTypeIds.length } });
}

/** Visuel d'un code, dans une collection alimentée par {@link listVisualUrls}. */
export const getVisualUrl = (
	code: CodeModel,
	collection: ApiCollection<CodeTypePropertyValueModel>,
) => {
	const codeTypeId = code.getId('codeType');

	return collection.find(ctpv => String(ctpv.getId('codeType')) === String(codeTypeId))?.value || '';
}
